<div class="filters-row">
  <mat-form-field
    class="filter-select"
    appearance="outline"
    subscriptSizing="dynamic">
    <mat-label>Endereço</mat-label>
    <mat-select
      [value]="selectedBranchId()"
      (selectionChange)="onBranchChange($event.value)">
      <mat-option [value]="'all'">Todos os endereços</mat-option>
      @for (branch of branches(); track branch.id) {
        <mat-option [value]="branch.id.toString()">{{ branch.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field
    class="filter-select"
    appearance="outline"
    subscriptSizing="dynamic">
    <mat-label>Comprador</mat-label>
    <mat-select
      #buyerSelect
      [value]="selectedBuyerId()"
      (selectionChange)="onBuyerChange($event.value)"
      (opened)="onBuyerSelectOpened()"
      (closed)="onBuyerSelectClosed()">
      <mat-option [value]="'all'">Todos os compradores</mat-option>
      <mat-option [value]="'me'">Atribuídos a mim</mat-option>
      @for (buyer of buyers(); track buyer.id) {
        <mat-option [value]="buyer.id">
          <div class="buyer-option">
            <seed-user-avatar
              [size]="24"
              [src]="buyer.avatar" />
            <span class="buyer-name">{{ buyer.name }}</span>
          </div>
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field
    class="filter-select filter-select--order"
    appearance="outline"
    subscriptSizing="dynamic">
    <mat-label>Ordenar por</mat-label>
    <mat-select
      [value]="selectedOrderValue()"
      (selectionChange)="onOrderChange($event.value)">
      <mat-option [value]="'default'">Padrão</mat-option>
      @for (option of orderOptions; track option.label) {
        <mat-option [value]="orderOptionValue(option)">{{ option.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button
    matButton="outlined"
    type="button"
    class="quick-filter"
    [class.quick-filter--active]="isMineActive()"
    [attr.aria-pressed]="isMineActive()"
    (click)="toggleMine()">
    <mat-icon aria-hidden="true">{{ isMineActive() ? 'person_check' : 'person' }}</mat-icon>
    Atribuídas a mim
  </button>

  <aionz-input-search
    class="global-search"
    [formControl]="searchControl"
    placeholder="Buscar por título, código, solicitante ou comprador…" />
</div>

@if (activeFilters().length > 0) {
  <div
    class="active-filters"
    role="status"
    aria-live="polite">
    <span class="active-filters-label">Filtrando por</span>
    <mat-chip-set aria-label="Filtros ativos">
      @for (chip of activeFilters(); track chip.kind) {
        <mat-chip-row
          [editable]="false"
          (removed)="removeFilter(chip)">
          <span class="active-filter-name">{{ chip.name }}:</span>
          {{ chip.value }}
          <button
            matChipRemove
            type="button"
            [attr.aria-label]="'Remover filtro ' + chip.name + ': ' + chip.value">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-set>
    <button
      matButton
      type="button"
      class="clear-filters-btn"
      (click)="onClearFilters()">
      <mat-icon aria-hidden="true">filter_alt_off</mat-icon>
      Limpar filtros
    </button>
  </div>
}
